<template>
  <div class="home">
    <img alt="Chb2 logo" src="../assets/logo.png">
  </div>
</template>

<script>

export default {
  name: 'Home'
}
</script>
